import { Box, Group, Image, Text, UnstyledButton } from "@mantine/core";
import { router } from "@inertiajs/react";
import classes from "./FilterByCard.module.css"

import { IconArrowUpRight } from "@tabler/icons-react";
import { useColorScheme } from "@mantine/hooks";

export const FilterByCard = (props) => {

    const {
        title, 
        description, 
        image, 
        image_dark, 
        link
    } = props;

    const colorScheme = useColorScheme();

    return (
        <UnstyledButton onClick={() => router.visit(link)}>
            <Box mx="auto">
                <Image
                    radius="md"
                    src={colorScheme === 'dark' ? image_dark : image}
                />
                <Group mt="xs" justify="space-between">
                    <Text className={classes.title}>{title} <Text span fw={400} style={{ color: 'var(--mantine-color-figma-grey-4)'}} fz="16px" ml={2}>{description}</Text></Text>
                    <IconArrowUpRight stroke={1}/>
                </Group>
            </Box>
        </UnstyledButton>
    )
}